// extracted by mini-css-extract-plugin
export default {"beianhao":"index_beianhao__H2FRa"};